'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useSession } from '@marketplace-web/shared/session-data'
import {
  ConversationActionProps,
  ConversationActionButton,
  ConversationActionType,
} from '@marketplace-web/messaging/conversation-action-feature'

import { MEMBER_PROFILE_URL } from 'constants/routes'
import { Screen } from 'constants/tracking/screens'
import { clickEvent, viewEvent } from '_libs/common/event-tracker/events'
import { ClickableElement } from 'constants/tracking/clickable-elements'

const PromotedClosetPrecheckout = ({
  primary,
  title,
  inverse,
  theme,
  size,
}: ConversationActionProps) => {
  const { user: currentUser } = useSession()
  const { track } = useTracking()

  useEffect(() => {
    if (!currentUser) return
    track(
      viewEvent({
        screen: Screen.MessageReply,
        target: 'cp_reminder',
        targetDetails: JSON.stringify({
          action: ConversationActionType.PromotedClosetPrecheckout,
        }),
      }),
    )
  }, [track, currentUser])

  const handleClick = () => {
    track(
      clickEvent({
        screen: Screen.MessageReply,
        target: ClickableElement.CpReminder,
        targetDetails: JSON.stringify({
          action: ConversationActionType.PromotedClosetPrecheckout,
        }),
      }),
    )
  }

  if (!currentUser) return null

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      url={MEMBER_PROFILE_URL(currentUser.id, true)}
      onClick={handleClick}
    />
  )
}

export default PromotedClosetPrecheckout
